import { Suspense } from "react";
import Navigation from "./../components/Navigation";
import { Main, Header, Img, Rubrik1, Rubrik2 } from "../styles/AboutStyles";
import SEO from "./../components/SEO";

import krogen from "./../images/krogen_close.jpg";
import rubrik1 from "./../images/rubrik_history1.png";
import rubrik2 from "./../images/rubrik_history2.png";
import HomeButton from "../components/HomeButton";
import { useContent } from "../i18n/useContent";

const History = () => {
    const Content = useContent('history');

    return (
        <>
            <SEO pageKey="history" />
            <Navigation page={'history'} />

            <Main>
                <article>
                    <Header><h1 alt={"Oxelö Krogs och Gamla Oxelösunds historia"}><Rubrik1 src={rubrik1} width='54%' /><Rubrik2 src={rubrik2} width='84%' width2='46%' /></h1> </Header>
                    <div>
                        <Img src={krogen} />
                        <Suspense fallback={<div>...</div>}>
                            <Content />
                        </Suspense>
                    </div>
                    <HomeButton />
                </article>
            </Main>
        </>
    );
}

export default History;
